(function () {
  function formatMoney(cents) {
    try { 
      return Shopify.formatMoney ? Shopify.formatMoney(cents) : (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL' }); 
    } catch { 
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); 
    }
  }

  function getCartSubtotal() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.total_price || 0; })
      .catch(function () { return 0; });
  }

  function updateProgressBarEnhanced(container) {
    const checkpointsJson = container.querySelector('#progress-checkpoints');
    if (!checkpointsJson) return;

    const checkpointsText = checkpointsJson.textContent;
    if (!checkpointsText) return;

    let checkpoints;
    try {
      checkpoints = JSON.parse(checkpointsText);
    } catch (error) {
      console.error('Error parsing checkpoints JSON:', error);
      return;
    }

    if (!Array.isArray(checkpoints) || checkpoints.length === 0) return;

    getCartSubtotal().then(function (subtotal) {
      // subtotal vem em centavos do cart.js
      const currentTotalCents = subtotal;

      // Valores vêm em reais do JSON, converter para centavos para comparação
      // Se o valor for menor que 1, assumir que foi salvo incorretamente em centavos e já está em reais
      checkpoints.forEach(cp => {
        // Se valor < 1, pode ser que foi salvo como centavos (ex: 0.20 = 20 centavos)
        // Mas como queremos trabalhar sempre em reais, vamos assumir que valores < 1 são erros
        // e precisam ser multiplicados por 100 para converter centavos para reais primeiro
        let valueInReais = cp.value;
        if (valueInReais > 0 && valueInReais < 1) {
          // Valor parece estar em centavos (ex: 0.20), converter para reais (20)
          valueInReais = valueInReais * 100;
        }
        cp.valueCents = valueInReais * 100;
      });
      checkpoints.sort((a, b) => a.valueCents - b.valueCents);
      const maxValueCents = checkpoints[checkpoints.length - 1].valueCents;
      
      let progressPercentage;
      if (maxValueCents === 0) {
        progressPercentage = 100;
      } else {
        progressPercentage = Math.min((currentTotalCents / maxValueCents) * 100, 100);
      }
      
      // Garantir que nunca ultrapasse 100%
      progressPercentage = Math.min(progressPercentage, 100);

      /** @type {{value: number, valueCents: number, id: number} | null} */
      let nextCp = null;
      for (const cp of checkpoints) {
        if (cp.valueCents > currentTotalCents) {
          if (nextCp === null || cp.valueCents < nextCp.valueCents) {
            nextCp = { value: cp.value, valueCents: cp.valueCents, id: cp.id };
          }
        }
      }

      const progressFill = container.querySelector('.progress-fill-enhanced');
      if (progressFill instanceof HTMLElement) {
        // Garantir que o width nunca ultrapasse 100%
        const finalWidth = Math.min(progressPercentage, 100);
        progressFill.style.width = `${finalWidth}%`;
      }

      const messageElem = container.querySelector('.progress-message-enhanced');
      if (messageElem instanceof HTMLElement) {
        if (nextCp && nextCp !== null) {
          // Calcular diferença em centavos e converter para reais
          const remainingCents = nextCp.valueCents - currentTotalCents;
          const remainingReais = remainingCents / 100;
          const formattedRemaining = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(remainingReais);
          const messageElement = container.querySelector(`#checkpoint-messages [data-id="${nextCp.id}"]`);
          const messageContent = messageElement ? messageElement.textContent || messageElement.innerHTML : '';
          const progressText = messageElem.querySelector('.progress-text');
          if (progressText) {
            progressText.innerHTML = messageContent.replace('{amount}', formattedRemaining);
            progressText.classList.remove('progress-complete');
          }
        } else {
          const completionElement = container.querySelector('#completion-message');
          const progressText = messageElem.querySelector('.progress-text');
          if (progressText) {
            progressText.innerHTML = completionElement ? completionElement.textContent || completionElement.innerHTML : '';
            progressText.classList.add('progress-complete');
          }
        }
      }

      container.querySelectorAll('.checkpoint-enhanced').forEach(el => {
        if (!(el instanceof HTMLElement)) return;
        const datasetValue = el.dataset.value;
        if (!datasetValue) return;
        // data-value já está em centavos (vem do Liquid)
        const cpValueCents = parseFloat(datasetValue);
        if (isNaN(cpValueCents)) return;
        if (cpValueCents <= currentTotalCents) {
          el.classList.add('reached');
        } else {
          el.classList.remove('reached');
        }
      });
    }).catch(function () { /* noop */ });
  }

  function updateAll() {
    var roots = document.querySelectorAll('.cart-progress-enhanced');
    if (!roots.length) {
      setTimeout(function() {
        var delayedRoots = document.querySelectorAll('.cart-progress-enhanced');
        if (delayedRoots.length) updateAll();
      }, 300);
      return;
    }

    roots.forEach(function (root) {
      updateProgressBarEnhanced(root);
    });
  }

  window.CartProgressBar = window.CartProgressBar || { update: updateAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else setTimeout(updateAll, 100);

  document.addEventListener('cart:updated', updateAll);
  document.addEventListener('theme:cart-update', updateAll);
  document.addEventListener('cart:update', updateAll);
  document.addEventListener('dialog:opened', function() { setTimeout(updateAll, 200); });

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var needs = mutations.some(function(m) {
        return Array.prototype.some.call(m.addedNodes, function(n) {
          return n.nodeType === 1 && (n.classList && n.classList.contains('cart-progress-enhanced') || (n.querySelector && n.querySelector('.cart-progress-enhanced')));
        });
      });
      if (needs) setTimeout(updateAll, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
